import React, { useState } from "react";
import { styled } from "styled-components";
import axios from "axios";
import Loading from "../Common/Loading";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { endLoading, startLoading } from "../../modules/loading";
import { MdCloudDownload } from "react-icons/md";
import Title from "../Common/Title";
import Header from "../Common/Header";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    background: linear-gradient(135deg, var(--card-bg-color), var(--bg-color));
    transition: 0.3s;
    max-width: 100% !important;
`;
const Box = styled.div`
    width: 80%;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;

    &.content {
        flex-direction: column;
    }

    & button {
        margin: 24px;
        padding: 12px;
        width: 120px;

        border: none;
        border-radius: 8px;
        background: linear-gradient(90deg, var(--btn-bg-color), var(--accent-color));
        color: white;
        text-decoration: underline;
        font-size: 0.825rem;
        height: 54px;

        cursor: pointer;
    }

    & textarea {
        width: 80%;
        height: 50vh;
        resize: none;
        margin-top: 12px;
        margin-bottom: 24px;
        max-width: 520px;

        background: var(--bg-color);
        border: 2px solid var(--text-color);
        color: var(--text-color);

        /* transition: 0.1s; */
    }

    & img {
        margin-top: 24px;
        margin-bottom: 24px;
        max-width: 100%;
    }
`;

const TomorrowPage = () => {
    const [tomorrowHtml, setTomorrowHtml] = useState("");
    const [imageSrc, setImageSrc] = useState("");
    const { loading } = useSelector((state: any) => ({
        loading: state.loading.state
    }));

    const dispatch = useDispatch();

    const copyImageToClipboard = async (blob: Blob) => {
        try {
            const data = [new ClipboardItem({ 'image/png': blob })];
            await navigator.clipboard.write(data);
            console.log('Image copied to clipboard');
        } catch (error) {
            console.error('Failed to copy image to clipboard:', error);
        }
    };

    const onClick = (e: any) => {
        if(loading) return;
        dispatch(startLoading());
        axios.get('/api/tomorrow/')
        .then((response) => {
            // console.log(response);
            setTomorrowHtml(response.data.text);
            
            // 16진수 문자열을 바이너리로 변환 후 Blob으로 만들기
            const base64String = response.data.image;
            
            const binaryString = atob(base64String);
            
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            
            // Blob 생성 시 MIME 타입 명시
            const blob = new Blob([bytes], { type: 'image/png' });
            
            // Blob URL 생성
            const imageUrl = URL.createObjectURL(blob);
            
            setImageSrc(imageUrl);

            // 클립보드에 이미지 복사
            copyImageToClipboard(blob);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            dispatch(endLoading());
        })
    };
    return (
        <Wrapper>
            <Header />
            <Title desc='Tomorrow' />
            {loading && <Loading />}
            <Box>
                <button onClick={onClick}><MdCloudDownload size={'2rem'} /></button>
            </Box>
            <Box className="content">
                <textarea id='htmlText' value={tomorrowHtml} readOnly></textarea>
                {imageSrc && (
                    <img 
                        src={imageSrc} 
                        alt="TomorrowKoreanWeather" 
                        onError={(e) => console.error('Image loading error:', e)}
                    />
                )}
            </Box>
        </Wrapper>
    );
};

export default TomorrowPage;